// Lightweight A/B variant selector.
//
// Reads the active experience variant from the URL query string (`?variant=b`)
// so we can trial an alternate hero/landing without a build flag or a redeploy.
// Defaults to "a" (the original layout). Anything other than "b" falls back to
// "a" so a stray value can never break the start screen.
//
// Kept intentionally dependency-free and SSR-safe (guards `window`) so it can be
// imported from anywhere, including module top-level.

export type ExperienceVariant = "a" | "b";

export function readVariant(): ExperienceVariant {
  if (typeof window === "undefined") return "a";
  try {
    const value = new URLSearchParams(window.location.search)
      .get("variant")
      ?.trim()
      .toLowerCase();
    return value === "b" ? "b" : "a";
  } catch {
    return "a";
  }
}
